import React from 'react';
import { FormControl, FormHelperText } from '@material-ui/core';
import { Select, Progress } from '@backstage/core-components';
import useBillingCompaniesPicker from './hooks';

export const BillingCompaniesPickerSchema = {
  uiOptions: {
    type: 'object',
    properties: {},
  },
  returnValue: { type: 'string' },
};

export const BillingCompaniesPicker = (props: any) => {
  const { onChange, schema, required, formData } = props;
  const { options, loading, error } = useBillingCompaniesPicker();

  if (loading) {
    return <Progress />;
  }

  if (error) {
    return (
      <FormControl margin="normal" error>
        <FormHelperText>Error loading companies: {error}</FormHelperText>
      </FormControl>
    );
  }

  return (
    <FormControl
      margin="normal"
      required={required}
      error={required && !formData}
    >
      <Select
        label={schema.title || 'Billing Company'}
        placeholder="Select a company"
        items={options}
        onChange={onChange}
        selected={formData || ''}
      />
      {schema.description && (
        <FormHelperText>{schema.description}</FormHelperText>
      )}
    </FormControl>
  );
};